import React from "react"

const Headline = () => (
  <section className="py-20">
    <div className="container max-w-screen-lg mx-auto px-5 text-center">
      <h1 className="text-4xl font-heading text-gray-900 mb-4">A touching film about real people</h1>
      <p className="text-xl">We have all grown up watching romance on TV. It is television that has brought many aspects of romance to the forefront. We can always count on TV to be dramatic and, the kind of romance on TV is one that has been unrealistically perfected. There are so many shows on TV that show romance exclusively while others will have some romantic beginning or ending.</p>
    </div>
  </section>
)

export default Headline